import { ChangeEvent } from 'react';
import { SxProps, TablePagination, Theme } from '@mui/material';

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (nextPage: number) => void;
  onRowsPerPageChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  sx?: SxProps<Theme>;
};

const baseSx: SxProps<Theme> = {
  borderTop: 0,
  height: '42px',
  overflow: 'hidden',
  '.MuiTablePagination-selectLabel': { mt: 0, mb: 0 },
  '.MuiTablePagination-displayedRows': { mt: 0, mb: 0 },
  '.MuiTablePagination-actions': { ml: 0 },
};

export const CursorTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  sx,
}: Props) => (
  <TablePagination
    component={'div'}
    sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]}
    count={count}
    page={page}
    rowsPerPage={rowsPerPage}
    onPageChange={(_event: unknown, nextPage) => onPageChange(nextPage)}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);
